export default {
  SET_FINANCIAL_CLUB_INFO (state, financialClubInfo) {
    state.financialClubInfo = financialClubInfo
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/financialClubInfo.js